// Application footer with copyright and version info

import { css, html } from 'lit';
import { api } from '../../lib/api.js';
import { BaseComponent } from '../../lib/base-component.js';

class AppFooter extends BaseComponent {
  static properties = {
    _versionInfo: { type: Object, state: true },
  };

  static styles = css`
    :host {
      display: block;
      flex-shrink: 0;
    }

    footer {
      background-color: #f8f9fa;
      border-top: 1px solid #dee2e6;
      padding: 0.5rem 1rem;
      font-size: 0.875rem;
      color: #6c757d;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  `;

  constructor() {
    super();
    /** @type {{version: string, gitCommit: string, buildDate: string}|null} */
    this._versionInfo = null;
  }

  async connectedCallback() {
    await super.connectedCallback();
    this._fetchVersion();
  }

  async _fetchVersion() {
    try {
      this._versionInfo = await api.get('/api/service/version');
    } catch {
      // Silently fail - version display is not critical
    }
  }

  render() {
    return html`
      <footer>
        <span>RPGish™ is copyright Dice Driven Design, LLC. All rights are reserved.</span>
        ${
          this._versionInfo
            ? html`
              <span>${this._versionInfo.version} (${this._versionInfo.gitCommit}, ${this._versionInfo.buildDate})</span>
            `
            : ''
        }
      </footer>
    `;
  }
}

customElements.define('app-footer', AppFooter);
